import React from "react";
// reactstrap components
import {Card, CardBody, CardTitle, Col, Container, Row} from "reactstrap";
import {Redirect} from "react-router-dom";
import ErrorModal from "../Alerts/ErrorModal";
import LocalizedStrings from "react-localization";
import {report_strings} from "../../translations/report_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import Label from "reactstrap/es/Label";
import clientHelper from "../../helpers/ClientHelper";

let reportStrings = new LocalizedStrings(report_strings);

const test_stats = {
    "tickets": 0,
    "tickets_perc": 0,
    "clients": 0,
    "clients_lw": 0,
    "clients_perc": 0,
    "attendance": 0,
    "attendance_perc": 0,
    "bookings": 0,
    "booking_perc": 0
};

class DiscoverHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            client: clientHelper.client(),
            error: null,
            showError: false,
            stats: null
        };
    }

    toggleErrorModal = this.toggleErrorModal.bind(this);

    componentDidMount() {
        this.setState({isLoading: true});
        if (!localStorage.getItem('at') || !localStorage.getItem('client')) {
            return <Redirect from="*" to="/auth/login"/>
        } else {
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        reportStrings.setLanguage(loc);
    }

    render() {
        this.localize();

        let back = "url(" + require("assets/img/theme/yoga-index.jpg") + ")";

        return (
            <>
                {this.state.showError && <ErrorModal showError={this.state.showError} error={this.state.error}
                                                     toggleErrorModal={this.toggleErrorModal}/>}
                <div className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style={{
                         backgroundImage: back,
                         backgroundSize: "cover",
                         backgroundPosition: "center"
                     }}
                >
                    {/* Mask */}
                    <span className="mask bg-gradient-dark opacity-9"/>
                    <Container fluid>
                        <div className="header-body">
                            <Row>
                                <Label className="text-white ml-3">
                                    {reportStrings.this_week}
                                </Label>
                            </Row>
                            {/* Card stats */}
                          {/*  <Row>*/}
                          {/*      <Col lg="6" xl="3">*/}
                          {/*          <Card className="card-stats mb-4 mb-xl-0"*/}
                          {/*                onClick={(e) => this.props.goToTicketReport(e)}*/}
                          {/*                style={{cursor: "pointer"}}*/}
                          {/*          >*/}
                          {/*              <CardBody>*/}
                          {/*                  <Row>*/}
                          {/*                      <div className="col">*/}
                          {/*                          <CardTitle*/}
                          {/*                              tag="h5"*/}
                          {/*                              className="text-uppercase text-muted mb-0"*/}
                          {/*                          >*/}
                          {/*                              {reportStrings.tickets_sold}*/}
                          {/*                          </CardTitle>*/}
                          {/*                          <span className="h2 font-weight-bold mb-0">*/}
                          {/*                          {this.state.stats && this.state.stats.tickets ? this.state.stats.tickets.toString() : "0"}*/}
                          {/*                          </span>*/}
                          {/*                      </div>*/}
                          {/*                      <Col className="col-auto">*/}
                          {/*                          <div*/}
                          {/*                              className="icon icon-shape bg-danger text-white rounded-circle shadow">*/}
                          {/*                              <i className="fas fa-ticket-alt"/>*/}
                          {/*                          </div>*/}
                          {/*                      </Col>*/}
                          {/*                  </Row>*/}
                          {/*                  {this.renderTicketStats()}*/}
                          {/*              </CardBody>*/}
                          {/*          </Card>*/}
                          {/*      </Col>*/}
                          {/*      <Col lg="6" xl="3">*/}
                          {/*          <Card className="card-stats mb-4 mb-xl-0"*/}
                          {/*                onClick={(e) => this.props.goToClients(e)}*/}
                          {/*                style={{cursor: "pointer"}}>*/}
                          {/*              <CardBody>*/}
                          {/*                  <Row>*/}
                          {/*                      <div className="col">*/}
                          {/*                          <CardTitle*/}
                          {/*                              tag="h5"*/}
                          {/*                              className="text-uppercase text-muted mb-0"*/}
                          {/*                          >*/}
                          {/*                              {reportStrings.new_clients}*/}
                          {/*                          </CardTitle>*/}
                          {/*                          <span className="h2 font-weight-bold mb-0">*/}
                          {/*  {this.state.stats && this.state.stats.clients ? this.state.stats.clients.toString() : "0"}*/}
                          {/*</span>*/}
                          {/*                      </div>*/}
                          {/*                      <Col className="col-auto">*/}
                          {/*                          <div*/}
                          {/*                              className="icon icon-shape bg-warning text-white rounded-circle shadow">*/}
                          {/*                              <i className="fas fa-user"/>*/}
                          {/*                          </div>*/}
                          {/*                      </Col>*/}
                          {/*                  </Row>*/}
                          {/*                  {this.state.stats && this.state.stats.clients_perc &&*/}
                          {/*                  this.state.stats.clients_perc > 0 ?*/}
                          {/*                      (<p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-success mr-2">*/}
                          {/*    <i className="fa fa-arrow-up"/> {this.state.stats.clients_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                          <span className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                      </p>) : this.state.stats.clients_perc < 0 ?*/}
                          {/*                          (<p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-danger mr-2">*/}
                          {/*    <i className="fa fa-arrow-down"/> {this.state.stats.clients_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                              <span*/}
                          {/*                                  className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                          </p>) : (*/}
                          {/*                              <p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*                      <span className="text-success mr-2">*/}
                          {/*                      <i className="fa"/> {this.state.stats.clients_perc}%*/}
                          {/*                      </span>{" "}*/}
                          {/*                                  <span*/}
                          {/*                                      className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                              </p>*/}
                          {/*                          )*/}
                          {/*                  }*/}
                          {/*              </CardBody>*/}
                          {/*          </Card>*/}
                          {/*      </Col>*/}
                          {/*      <Col lg="6" xl="3">*/}
                          {/*          <Card className="card-stats mb-4 mb-xl-0">*/}
                          {/*              <CardBody>*/}
                          {/*                  <Row>*/}
                          {/*                      <div className="col">*/}
                          {/*                          <CardTitle*/}
                          {/*                              tag="h5"*/}
                          {/*                              className="text-uppercase text-muted mb-0"*/}
                          {/*                          >*/}
                          {/*                              {reportStrings.attendance}*/}
                          {/*                          </CardTitle>*/}
                          {/*                          <span className="h2 font-weight-bold mb-0">*/}
                          {/*  {this.state.stats && this.state.stats.attendance ? this.state.stats.attendance.toString() : "0"}*/}
                          {/*</span>*/}
                          {/*                      </div>*/}
                          {/*                      <Col className="col-auto">*/}
                          {/*                          <div*/}
                          {/*                              className="icon icon-shape bg-yellow text-white rounded-circle shadow">*/}
                          {/*                              <i className="fas fa-users"/>*/}
                          {/*                          </div>*/}
                          {/*                      </Col>*/}
                          {/*                  </Row>*/}
                          {/*                  {this.state.stats && this.state.stats.attendance_perc &&*/}
                          {/*                  this.state.stats.attendance_perc > 0 ?*/}
                          {/*                      (<p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-success mr-2">*/}
                          {/*    <i className="fa fa-arrow-up"/> {this.state.stats.attendance_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                          <span className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                      </p>) : this.state.stats.attendance_perc < 0 ?*/}
                          {/*                          (<p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-danger mr-2">*/}
                          {/*    <i className="fa fa-arrow-down"/> {this.state.stats.attendance_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                              <span*/}
                          {/*                                  className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                          </p>) : (*/}
                          {/*                              <p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*                      <span className="text-success mr-2">*/}
                          {/*                      <i className="fa"/> {this.state.stats.attendance_perc}%*/}
                          {/*                      </span>{" "}*/}
                          {/*                                  <span*/}
                          {/*                                      className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                              </p>*/}
                          {/*                          )*/}
                          {/*                  }*/}
                          {/*              </CardBody>*/}
                          {/*          </Card>*/}
                          {/*      </Col>*/}
                          {/*      <Col lg="6" xl="3">*/}
                          {/*          <Card className="card-stats mb-4 mb-xl-0">*/}
                          {/*              <CardBody>*/}
                          {/*                  <Row>*/}
                          {/*                      <div className="col">*/}
                          {/*                          <CardTitle*/}
                          {/*                              tag="h5"*/}
                          {/*                              className="text-uppercase text-muted mb-0"*/}
                          {/*                          >*/}
                          {/*                              {reportStrings.bookings}*/}
                          {/*                          </CardTitle>*/}
                          {/*                          <span className="h2 font-weight-bold mb-0">*/}
                          {/*  {this.state.stats && this.state.stats.bookings ? this.state.stats.bookings.toString() : "0"}*/}
                          {/*</span>*/}
                          {/*                      </div>*/}
                          {/*                      <Col className="col-auto">*/}
                          {/*                          <div*/}
                          {/*                              className="icon icon-shape bg-info text-white rounded-circle shadow">*/}
                          {/*                              <i className="fas fa-mobile-alt"/>*/}
                          {/*                          </div>*/}
                          {/*                      </Col>*/}
                          {/*                  </Row>*/}
                          {/*                  {this.state.stats && this.state.stats.booking_perc &&*/}
                          {/*                  this.state.stats.booking_perc > 0 ?*/}
                          {/*                      (<p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-success mr-2">*/}
                          {/*    <i className="fa fa-arrow-up"/> {this.state.stats.booking_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                          <span className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                      </p>) : this.state.stats.booking_perc < 0 ?*/}
                          {/*                          (<p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-danger mr-2">*/}
                          {/*    <i className="fa fa-arrow-down"/> {this.state.stats.booking_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                              <span*/}
                          {/*                                  className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                          </p>) : (*/}
                          {/*                              <p className="mt-3 mb-0 text-muted text-sm">*/}
                          {/*  <span className="text-success mr-2">*/}
                          {/*    <i className="fa"/> {this.state.stats.booking_perc}%*/}
                          {/*  </span>{" "}*/}
                          {/*                                  <span*/}
                          {/*                                      className="text-nowrap">{reportStrings.since_last_week}</span>*/}
                          {/*                              </p>*/}
                          {/*                          )*/}
                          {/*                  }*/}
                          {/*              </CardBody>*/}
                          {/*          </Card>*/}
                          {/*      </Col>*/}
                          {/*  </Row>*/}
                        </div>
                    </Container>
                </div>
            </>
        );
    }

    renderTicketStats() {
        if (this.state.stats && this.state.stats.tickets_perc !== undefined)
            if (this.state.stats.tickets_perc > 0) {
                return <p className="mt-3 mb-0 text-muted text-sm">
                                                    <span className="text-success mr-2">
                                                      <i className="fa fa-arrow-up"/> {this.state.stats.tickets_perc}%
                                                    </span>{" "}
                    <span className="text-nowrap">{reportStrings.since_last_week}</span>
                </p>
            } else if (this.state.stats.tickets_perc < 0)
                return <p className="mt-3 mb-0 text-muted text-sm">
                                                        <span className="text-danger mr-2">
                                                          <i className="fa fa-arrow-down"/> {this.state.stats.tickets_perc}%
                                                        </span>{" "}
                    <span className="text-nowrap">{reportStrings.since_last_week}</span>
                </p>;
            else return <p className="mt-3 mb-0 text-muted text-sm">
                                                    <span className="text-success mr-2">
                                                     {this.state.stats.tickets_perc}%
                                                    </span>{" "}
                    <span className="text-nowrap">{reportStrings.since_last_week}</span>
                </p>

    }
}

export default DiscoverHeader;
